import React from 'react';

interface MainProps {}

const Main: React.FC<MainProps> = () => {
    return (
        <React.Fragment>
            <h4>Health Check</h4>
        </React.Fragment>
    );
};

export default Main;
